class SuggestedView {
  constructor(readonly _name: string, readonly _query: string) {}

  static build(serverObj: SuggestedView) {
    return new SuggestedView(serverObj._name, serverObj._query);
  }

  name() {
    return this._name;
  }

  query() {
    return this._query;
  }
}

export default SuggestedView;
